import React, {PropTypes} from 'react';
import {FormControl} from 'react-bootstrap';
import _ from 'lodash';
import onClickOutside from 'react-onclickoutside';
import { List } from 'react-virtualized';
import './styles.scss';

class VirtualDropdown extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      text: undefined,
      showList: false,
      elements: []
    }
    this.elements = [];
  }

  componentDidMount() {
    const { elements } = this.props;
    this.setState({ elements: elements });
  }

  componentWillReceiveProps(nextProps) {
    this.setState({ elements: nextProps.elements });
  }

  elementsRowRenderer = ({
    key,         // Unique key within array of rows
    index,       // Index of row within collection
    isScrolling, // The List is currently being scrolled
    isVisible,   // This row is visible within the List (eg it is not an overscanned row)
    style        // Style object to be applied to row (to position it)
  }, elements) => {
    return (
      <div
        key={key}
        style={style}
        onClick={() => {
          this.props.onSelect(elements[index]);
          this.hideList();
          this.setState({text: elements[index].name});
          this.props.onSelect(elements[index]);
        }} >
        {elements[index].name}
      </div>
    )
  }

  hideList = () => {
    this.setState({ showList: false });
  }

  showList = () => {
    this.setState({ showList: true });
  }

  handleClickOutside = () => {
    this.setState({ showList: false });
  }

  renderListList = () => {
    //this.elements = this.props.elements;
    const { elements } = this.state;
    if(elements)
      return (
        <List
          width={300}
          height={200}
          rowCount={elements.length}
          rowHeight={20}
          rowRenderer={(e) => this.elementsRowRenderer(e, elements)}
        />
      )
  }

  change(e) {
    this.setState({ text: e.target.value });
    const { elements } = this.props;
    let temp = [];
    elements.map(element => {
      if(element.name.toLowerCase().includes(e.target.value.toLowerCase()))
        temp.push(element);
    })
    this.setState({ elements: temp });
    //this.elements = temp;
  }

  render() {
    const { defaultValue } = this.props;    
    return (
      <div className="virtual_dropdown">
        <FormControl
          type="text"
          className="virtual_input"
          contentEditable={false}
          defaultValue={defaultValue ? defaultValue : ''}
          onClick={() => {
            this.props.onOpen();
            this.showList();
          }}
          onChange={(e)=>this.change(e)}
          placeholder={this.props.placeholder}
          value={this.state.text}/>
        <span className="dropdown_triangle"/>
        {this.state.showList ?
          <div className='list_container'>
            {this.renderListList()}
          </div> : ''
        }
      </div>
    );
  }
}

VirtualDropdown.propTypes = {
  operators: PropTypes.array
};

export default onClickOutside(VirtualDropdown);



// WEBPACK FOOTER //
// ./src/components/virtualDropdown/index.js